import {
  AxisSwitcher,
  BorderGridContainer,
  Button,
  GridBox,
  H2,
  PortableText,
  Section,
  SpacerWrapper,
} from '@ahmdigital/ui';
import { chunk, isEmpty, map, size } from 'lodash/fp';
import React from 'react';

import InclusionsItem from './components/inclusion-item';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../../../../utils/uncap-fp-iterator';

const mediumSizeThreshold = '46rem';
const inclusionsPerRow = 2;

type InclusionsProps = {
  cta?: {
    name?: string;
    url?: string;
  };
  sellingPointGroup?: {
    name?: string;
    summary?: unknown[];
  }[];
  slogan?: unknown[];
  summary?: unknown[];
};

const Inclusions = ({ cta, slogan, summary, sellingPointGroup }: InclusionsProps) => {
  if (isEmpty(sellingPointGroup)) {
    return null;
  }

  const inclusionsGroupedByRow = chunk(inclusionsPerRow, sellingPointGroup);

  return (
    <BorderGridContainer>
      <GridBox padding="0">
        <Section variant={['paddingTopSpacer1', 'paddingBottomSpacer1', styles.section]}>
          <H2 variant="marginBottomSpacer8">
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[] | undefined' is not assignable to type 'PortableTextSource | undefined'. */}
            <PortableText source={slogan} />
          </H2>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
          {summary && <PortableText source={summary} variant={styles.summary} />}
          <SpacerWrapper variant={['marginBottomSpacer4', 'marginTopSpacer3']}>
            <AxisSwitcher space="0" limit={inclusionsPerRow} threshold={mediumSizeThreshold}>
              {uncapFpIterator(map)(
                // @ts-expect-error - Automatic, Please fix when editing this file
                (row, index) => (
                  <AxisSwitcher key={index} limit={inclusionsPerRow} space="0" threshold={mediumSizeThreshold}>
                    {map(({ summary: inclusionSummary, name: inclusionName }) => {
                      const isOdd = Boolean(size(row) % 2);
                      return (
                        <InclusionsItem
                          description={inclusionSummary}
                          itemTitle={inclusionName}
                          key={inclusionName}
                          isOdd={isOdd}
                        />
                      );
                    }, row)}
                  </AxisSwitcher>
                ),
                inclusionsGroupedByRow,
              )}
            </AxisSwitcher>
          </SpacerWrapper>
          {cta && (
            <Button variant={['white', 'border']} to={cta.url}>
              {cta.name}
            </Button>
          )}
        </Section>
      </GridBox>
    </BorderGridContainer>
  );
};

Inclusions.defaultProps = {
  cta: null,
  sellingPointGroup: null,
  slogan: null,
  summary: null,
};

export default Inclusions;
